import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { ReposeGroupEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ReposeGroupSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    reposeGroupsUpdated$() {
        return this.socketService.receiveMessageObserver(ReposeGroupEvents.REPOSE_GROUPS_UPDATED);
    }
}
